import api from '@/api/index'
import { getToken, setToken, setExpiresIn, removeToken, setExpiresState } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    creditCode: '',
    roles: [],
    permissions: [],
    isAdmin: undefined,
    isExpire: '',
    isBuy: '0',
    diffDate: '',
    partner: [],
    userMenu: [],
    userLevel: '',
    userLevelName:'',
    customerCode: '',
    customerName: '',
    phone: '',
    versionId: -1,
    versionName: '',
    expiredTime: '',
    newBuyDate: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_CREDITCODE: (state, creditCode) => {
      state.creditCode = creditCode
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_ISADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_DIFFDATE: (state, diffDate) => {
      state.diffDate = diffDate
    },
    SET_PARTNER: (state, partner) => {
      state.partner = partner
    },
    SET_USERMENU: (state, userMenu) => {
      state.userMenu = userMenu
    },
    SET_ISBUY: (state, isBuy) => {
      state.isBuy = isBuy
    },
    SET_ISEXPIRE: (state, isExpire) => {
      state.isExpire = isExpire
    },
    SET_USERlEVEL: (state, userLevel) => {
      state.userLevel = userLevel
    },
    SET_USERLEVEL_NAME:(state,userLevelName)=>{
      state.userLevelName=userLevelName
    },
    SET_CUSTOMERCODE: (state, customerCode) => {
      state.customerCode = customerCode
    },
    SET_CUSTOMERNAME: (state, customerName) => {
      state.customerName = customerName
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_VERSIONID: (state, versionId) => {
      state.versionId = versionId
    },
    SET_VERSIONNAME: (state, versionName) => {
      state.versionName = versionName
    },
    SET_EXPIREDTIME: (state, expiredTime) => {
      state.expiredTime = expiredTime
    },
    SET_NEWBUYDATE: (state, newBuyDate) => {
      state.newBuyDate = newBuyDate
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        const params = {
          username: username,
          password: password,
          code: code,
          uuid: uuid,
        }
        api.login(params).then(res => {
          let data = res.data
          setToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          setExpiresIn(data.expires_in)
          commit('SET_EXPIRES_IN', data.expires_in)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        api.getUserInfo().then(res => {
          const user = res.user
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', user.userName)
          commit('SET_ISADMIN', user.userId)
          commit('SET_CREDITCODE', user.creditCode)
          commit('SET_ISEXPIRE', res.isExpire)
          setExpiresState(res.isExpire)
          commit('SET_CUSTOMERCODE', res.customerCode)
          commit('SET_USERlEVEL', user.userLevel)
          commit('SET_CUSTOMERNAME', res.customerName)
          commit('SET_PHONE', user.phonenumber)
          api.getLevelList().then(res=>{
            const userLevelName = res.rows.find(item=>item.levelId==user.userLevel)
            commit('SET_USERLEVEL_NAME', userLevelName?userLevelName.levelName:'')
          })
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetSystemInfo({ commit }) {
      return new Promise((resolve, reject) => {
        api.getExpiryTime().then(res => {
          commit('SET_DIFFDATE', res.data.diffDate)
          commit('SET_ISBUY', res.data.isBuy)

          commit('SET_VERSIONID', res.data.versionId)
          commit('SET_VERSIONNAME', res.data.versionName)
          commit('SET_EXPIREDTIME', res.data.expiredTime)
          commit('SET_NEWBUYDATE', res.data.newBuyDate)

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取切换帐号列表
    GetPartner({ commit }) {
      return new Promise((resolve, reject) => {
        api.getParterList().then(res => {
          commit('SET_PARTNER', res.rows)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取路由信息
    GetRouter({ commit }) {
      return new Promise((resolve, reject) => {
        api.getUserRouters({ systemType: 3 }).then(res => {
          commit('SET_USERMENU', res.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          removeToken()
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
